import type { ContentObjectView, Poll, PollContentObjectDetail, PollContentObjectList } from 'models';
import { canViewPollChoicePercentage } from 'permissions';
import { ReadMore } from 'ui';
import { Attachments } from 'features/attachments';
import { useUser } from 'features/auth';
import { PollRendererCore } from 'features/polls';

type P = {
  item: PollContentObjectDetail | PollContentObjectList;
  showReadMore?: boolean;
  view: ContentObjectView;
};

/**
 * @deprecated This is only for port to tsx, dont inspire
 */
const PollContentObjectBody = ({ item, showReadMore, view }: P) => {
  const { railsUserData: viewer } = useUser();
  const { attachments, author, contentableType, pinned: isPinned, poll } = item;

  let programsTopicId;
  if (contentableType === 'Program') {
    const { programsTopic } = item;
    programsTopicId = programsTopic.id;
  }

  const pollData: Poll = {
    description: poll.description,
    endTime: poll.endTime,
    htmlDescription: poll.htmlDescription,
    id: poll.id,
    pinned: isPinned,
    postInCommunities: [],
    programsTopicId,
    questions: poll.questions,
    startTime: poll.startTime,
    title: poll.title,
  };

  const body = (
    <PollRendererCore
      isBookmark={view === 'bookmark'}
      isDisabled={author.id === viewer.id}
      poll={pollData}
      showChoicePercentage={canViewPollChoicePercentage({ contentObject: item, viewer })}
    />
  );

  return (
    <>
      {showReadMore ? <ReadMore>{body}</ReadMore> : body}
      <Attachments attachments={attachments} />
    </>
  );
};

export default PollContentObjectBody;
